module.exports = __webpack_public_path__ + "Unknown.ed829e4356d258eeba836b8f828ce695.hashedasset.svg";